import tripEvents from '../config/events.constant';

export default function TripCheckoutPaymentCodesController(
    $scope,
    tripAPI,
    railAmendmentService,
    paymentCodesService,
) {
    'ngInject';

    const vm = this;
    let isInvoiceSelected = false;
    $scope.touched = [];

    Object.assign(vm, {
        $onInit,
        model: {},
    });

    function $onInit() {
        subscribe();
        if ($scope.$parent.invoiceOnly.value) {
            isInvoiceSelected = true;
        }
    }

    function subscribe() {
        $scope.$on(tripEvents.TRIP_SHOW_PAYMENT_CODES, () => {
            isInvoiceSelected = true;
        });
        $scope.$on(tripEvents.TRIP_HIDE_PAYMENT_CODES, () => {
            isInvoiceSelected = false;
        });
        $scope.$on(tripEvents.TRIP_CANCEL_CHECKOUT_PROCESS, () => {
            isInvoiceSelected = false;
        });
        $scope.$on(tripEvents.TRIP_FINISH_HOLD, () => {
            isInvoiceSelected = false;
        });
        $scope.$on(tripEvents.TRIP_FINISH_BOOK, () => {
            isInvoiceSelected = false;
        });
    }

    $scope.isVisible = function() {
        return !_.isEmpty($scope.tripData.PaymentCodes)
            && [1, 3].indexOf($scope.tripData.PaymentCodeRequirementType) === -1
            && checkInvoice()
            && !hasBeenApproved()
            && !railAmendmentService.isAmendmentMode();
    };

    function hasBeenApproved() {
        return $scope.tripData.IsApproved === true;
    }

    $scope.hasBeenApproved = hasBeenApproved();

    $scope.actionData.getPaymentCodes = function() {
        return $scope.isVisible()
            ? paymentCodesService.getPaymentCodes(vm.model)
            : undefined;
    };

    $scope.showInvoiceNonEditableFields = showInvoiceNonEditableFields;

    function checkInvoice() {
        const needsToCheck = $scope.tripData.PaymentCodeRequirementType === 2 && !$scope.tripData.IncludeCreditCardBookings;
        return needsToCheck ? isInvoiceSelected : true;
    }

    function showInvoiceNonEditableFields() {
        return ($scope.tripData.IsApproved
            && !areEmptyPaymentCodes($scope.tripData.PaymentCodes)
            && ([1, 3].indexOf($scope.tripData.PaymentCodeRequirementType) === -1
            || railAmendmentService.isAmendmentMode()))
        && $scope.paymentCodes.length > 0;
    }

    function areEmptyPaymentCodes(codes) {
        const nonEmptyPaymentCodes = _.filter(codes, function filterOnlyCreditCodesWithValues(code) {
            return code.CodeValue;
        });
        return !nonEmptyPaymentCodes.length;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/tripCheckoutPaymentCodesController.js